import { useMemo, useState } from "react";
import Modal from "react-modal";

import { IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

import {
  useBannerPopups,
  type BannerPopup,
} from "../../hooks/queries/useBannerPopups";
import {
  hasSeenBannerPopup,
  markBannerPopupSeen,
} from "../../utils/bannerPopupSeen";

function PopupImage({ popup }: { popup: BannerPopup }) {
  const alt = popup.description?.trim() || "Campanha";

  if (popup.url) {
    return (
      <a
        href={popup.url}
        target={popup.urlType === "I" ? "_self" : "_blank"}
        rel="noreferrer"
        style={{ display: "block" }}
      >
        <img
          src={popup.image}
          alt={alt}
          style={{ maxWidth: "100%", height: "auto", verticalAlign: "middle" }}
        />
      </a>
    );
  }

  return (
    <img
      src={popup.image}
      alt={alt}
      style={{ maxWidth: "100%", height: "auto", verticalAlign: "middle" }}
    />
  );
}

const BannerPopupModal = () => {
  const { data: popups, isLoading, isError } = useBannerPopups();
  const [seenRevision, setSeenRevision] = useState(0);

  const popupToShow = useMemo(() => {
    if (isLoading || isError || !popups?.length) {
      return undefined;
    }
    return popups.find(p => p.image && !hasSeenBannerPopup(p.id));
  }, [popups, isLoading, isError, seenRevision]);

  const handleClose = () => {
    if (popupToShow) {
      markBannerPopupSeen(popupToShow.id);
    }
    setSeenRevision(n => n + 1);
  };

  if (!popupToShow) {
    return null;
  }

  const title = popupToShow.description?.trim() || "Campanha";

  return (
    <Modal
      isOpen
      className="modal"
      onRequestClose={handleClose}
      contentLabel={title}
      style={{ overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" } }}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
    >
      <div className="head">
        <h2>{title}</h2>
        <IconButton onClick={handleClose} type="button" aria-label="Fechar">
          <ClearIcon />
        </IconButton>
      </div>
      <div className="content">
        <PopupImage popup={popupToShow} />
        <p>
          <em>(Imagens meramente ilustrativas)</em>
        </p>
      </div>
    </Modal>
  );
};

export default BannerPopupModal;
